import { Link } from "react-router-dom";
import PublicFooter from "../components/PublicFooter";

const questions = [
  {
    question: "Hoe reserveer ik een aanhangwagen?",
    answer: "Je kiest op de website de gewenste aanhangwagen, controleert de beschikbaarheid en vult daarna je reservatiegegevens in. Na het indienen bekijkt DR Rentals je aanvraag en ontvang je verdere informatie per e-mail."
  },
  {
    question: "Moet ik een account aanmaken?",
    answer: "Nee. Klanten hoeven geen account aan te maken. Je reservatie en documenten worden opgevolgd via de gegevens die je bij je aanvraag invult en via unieke links die je van DR Rentals ontvangt."
  },
  {
    question: "Welke documenten moet ik uploaden?",
    answer: "Voor een reservatie vragen we doorgaans de voorkant en achterkant van je identiteitskaart, de voorkant en achterkant van je rijbewijs en het identificatieverslag van het trekkend voertuig."
  },
  {
    question: "Waarom moet ik mijn identiteitskaart en rijbewijs uploaden?",
    answer: "Deze documenten zijn nodig om je identiteit te controleren, na te gaan of je over het juiste rijbewijs beschikt en de verhuuradministratie correct en veilig te kunnen uitvoeren."
  },
  {
    question: "Hoe werkt de waarborg?",
    answer: "Bij de verhuur kan een waarborg gevraagd worden. Die dient als zekerheid voor schade, ontbrekende accessoires, laattijdige inlevering, reinigingskosten of andere kosten die uit de huur kunnen voortkomen."
  },
  {
    question: "Wanneer krijg ik mijn waarborg terug?",
    answer: "Na terugbrengst controleert DR Rentals de aanhangwagen, accessoires en eventuele schade. Als alles in orde is, wordt de waarborg administratief vrijgegeven of terugbetaald volgens de afgesproken betalingswijze."
  },
  {
    question: "Wat gebeurt er bij schade?",
    answer: "Schade wordt geregistreerd en beoordeeld. Indien de schade tijdens jouw huurperiode is ontstaan, kunnen herstelkosten of andere kosten geheel of gedeeltelijk met de waarborg verrekend worden."
  },
  {
    question: "Wat als ik te laat terugbreng?",
    answer: "Neem zo snel mogelijk contact op met DR Rentals. Laattijdige terugbrengst kan extra kosten veroorzaken, zeker wanneer de aanhangwagen opnieuw gereserveerd is voor een andere klant."
  },
  {
    question: "Kan ik mijn reservatie annuleren?",
    answer: "Ja, maar meld dit zo snel mogelijk via info@dr-rentals.be of 0479 65 88 28. Afhankelijk van het moment van annulatie en de gemaakte afspraken kunnen kosten van toepassing zijn."
  },
  {
    question: "Waar haal ik de aanhangwagen op?",
    answer: "De exacte ophaallocatie en praktische afspraken worden meegedeeld bij de bevestiging van je reservatie. Bij vragen kan je DR Rentals contacteren via info@dr-rentals.be."
  },
  {
    question: "Mag iemand anders de aanhangwagen ophalen?",
    answer: "Alleen na voorafgaande toestemming van DR Rentals. De persoon die ophaalt moet zich kunnen identificeren, het juiste rijbewijs hebben en de nodige controles kunnen uitvoeren."
  },
  {
    question: "Wat als ik problemen heb onderweg?",
    answer: "Contacteer DR Rentals onmiddellijk via 0479 65 88 28. Gebruik de aanhangwagen niet verder als dat onveilig is en meld schade, defecten of incidenten zo duidelijk mogelijk."
  },
  {
    question: "Hoe werkt check-in?",
    answer: "Check-in gebeurt bij het terugbrengen van de aanhangwagen. De staat van de aanhangwagen, foto's, accessoires en eventuele schade worden gecontroleerd en geregistreerd."
  },
  {
    question: "Hoe werkt check-out?",
    answer: "Check-out gebeurt bij ophaling. Je ontvangt een unieke link waarmee de staat van de aanhangwagen, foto's en eventuele opmerkingen kunnen worden bevestigd."
  },
  {
    question: "Is mijn reservatie pas definitief na bevestiging?",
    answer: "Ja. Een aanvraag is nog geen definitieve reservatie. Je reservatie is pas bevestigd wanneer DR Rentals deze heeft goedgekeurd en je de nodige instructies hebt ontvangen."
  }
];

export default function VeelgesteldeVragen({ user, onLogout }) {
  return (
    <main className="public-shell">
      <aside className="public-sidebar">
        <div className="sidebar-brand">
          <p className="sidebar-brand-title">DR Rentals</p>
          <p className="sidebar-brand-subtitle">Informatie</p>
        </div>

        <Link className="sidebar-button" to="/">Homepagina</Link>
        <Link className="sidebar-button" to="/contact">Contact</Link>
        {user && <Link className="sidebar-button" to="/dashboard">Dashboard</Link>}

        <div className="public-sidebar-bottom">
          {user ? (
            <button className="sidebar-button danger" onClick={onLogout}>Afmelden</button>
          ) : (
            <Link className="sidebar-button" to="/login">Medewerker login</Link>
          )}
        </div>
      </aside>

      <section className="public-page">
        <article className="panel panel-pad public-intro legal-page">
          <h1 className="page-title">Veelgestelde vragen</h1>
          <p className="page-subtitle">
            Hieronder vind je antwoorden op veelgestelde vragen over reserveren, documenten, waarborg, check-in en check-out bij DR Rentals.
          </p>

          <div className="faq-list">
            {questions.map((item) => (
              <details className="faq-item" key={item.question}>
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>

          <section className="legal-section">
            <h2>Contact</h2>
            <p>
              Nog vragen? Contacteer DR Rentals via info@dr-rentals.be of 0479 65 88 28.
            </p>
            <p>Ondernemingsnummer: BE 0720.658.431.</p>
          </section>
        </article>
        <PublicFooter />
      </section>
    </main>
  );
}
